import React from "react";
import { PageLoading } from "@ant-design/pro-layout";

const PageLoadingComponent = ({ tip }) => <PageLoading tip={tip || ""} />;

export default PageLoadingComponent;
